import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import EyeIcon from '@wix/da-ds/pkg/Icons/Eye';
import UnwatchIcon from '@wix/da-ds/pkg/Icons/Unwatch';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { canPeek } from '../../utils';
import { CommentContext } from '../../CommentContext';
import CommentDataAttrDiv from '../../lego/CommentDataAttrDiv';
import s from './HiddenView.scss';
var HiddenView = function () {
    var t = useTranslation().t;
    var _a = useContext(CommentContext), setPeeking = _a.setPeeking, comment = _a.comment;
    return (React.createElement(CommentDataAttrDiv, { className: s['root'] },
        canPeek(comment) && (React.createElement(PlainButtonOrLink, { className: c(s['hidden'], s['peekable']), onClick: function () { return setPeeking(true); } },
            React.createElement("span", { className: s['hidden-text'] },
                React.createElement(UnwatchIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.hidden')),
            React.createElement("span", { className: s['hidden-text-hover'] },
                React.createElement(EyeIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.hidden.showComment')))),
        !canPeek(comment) && (React.createElement("div", { className: s['hidden'] },
            React.createElement("span", { className: s['hidden-text'] },
                React.createElement(UnwatchIcon, { className: s['hidden-icon'] }),
                t('comment.visibility.hidden'))))));
};
HiddenView.displayName = 'HiddenView';
export default HiddenView;
//# sourceMappingURL=HiddenView.js.map